import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { addToCart } from "../store/slices/CartSlice";
import { RiShoppingCartLine } from "react-icons/ri";
import { FaEye, FaRegHeart, FaShareAlt } from "react-icons/fa";
import { FaCodeCompare } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import { getALLCategory } from "../apis/config";
import { products } from "../data/products";
import { addToComapre } from "../store/slices/CompareSlice";
import { addToWish } from "../store/slices/WishSlice";
import toast from "react-hot-toast";

const ProductCard = ({ data, rt }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [categorys, setCategorys] = useState([]);

  useEffect(() => {
    getALLCategory()
      .then((res) => setCategorys(res.data))
      .catch((err) => console.log(err));
  }, []);

  const handleAddProduct = (product) => {
    if (product.stockStatus === "out of stock") {
      toast.error(`${product.name} is currently out of stock`);
      return;
    }

    dispatch(addToCart({ ...product, quantity: 1 }));
    toast.success(`${product.name} added to your cart`);
  };

  const handleToCompare = (product) => {
    dispatch(addToComapre(product));
    toast.success(`${product.name} added to your compare`);
  };

  const handleToWish = (product) => {
    dispatch(addToWish(product));
    toast.success(`${product.name} added to your wish`);
  };

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const intervalRef = useRef(null);

  const startAutoSlide = () => {
    if (intervalRef.current) return;
    setIsHovered(true);
    intervalRef.current = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % data.images.length);
    }, 1000);
  };

  const stopAutoSlide = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
    setCurrentImageIndex(0);
    setIsHovered(false);
  };

  const currentImage = data.images[currentImageIndex];

  const handleShare = () => {
    const productUrl = `${window.location.origin}/products/${data._id}`;

    if (navigator.share) {
      navigator
        .share({
          title: data.name,
          text: "Check out this product!",
          url: productUrl,
        })
        .then(() => console.log("Shared successfully!"))
        .catch((error) => console.log("Share failed."));
    } else {
      // Fallback for browsers that don't support Web Share API
      navigator.clipboard
        .writeText(productUrl)
        .then(() => toast.success("Link copied to clipboard!"))
        .catch(() => toast.error("Failed to copy link."));
    }
  };

  return (
    <div
      //   key={index}
      className={`flex min-w-[160px] sm:w-[270px] ${
        rt ? " mx-auto md:mx-0" : "mx-auto"
      } flex-col shadow hover:shadow-xl hover:scale-[1.005] transition-all`}
    >
      <div className=" rounded-md relative flex flex-col justify-center items-center ">
        {/* <Link to={`/products/${data._id}`}> */}
        {/* <div className="relative group w-full h-[140px] sm:h-[240px] overflow-hidden">
            <img
              src={data.images[0]}
              alt="product"
              className="w-full h-full object-cover object-top duration-200 ease-in"
            /> */}

        {/* Side thumbnail list */}
        {/* <div className="absolute top-0 left-0 hidden group-hover:flex flex-col bg-white bg-opacity-90 p-1 gap-1 z-10 h-full overflow-y-auto">
              {data.images.slice(1).map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt={`thumb-${idx}`}
                  className="w-10 h-10 object-cover border border-gray-200 cursor-pointer hover:border-primary"
                  onMouseEnter={(e) => {
                    e.stopPropagation();
                    const mainImg = e.currentTarget.closest(".group").querySelector("img");
                    if (mainImg) mainImg.src = img;
                  }}
                />
              ))}
            </div>
          </div> */}
        <Link to={`/products/${data._id}`}>
          <div
            className="relative aspect-square overflow-hidden group"
            onMouseEnter={startAutoSlide}
            onMouseLeave={stopAutoSlide}
          >
            <img
              src={currentImage}
              alt="product"
              className="w-full h-full object-cover object-top duration-500 ease-in"
            />

            {/* Dots */}
            {isHovered && (
              <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex gap-1">
                {data.images.map((_, index) => (
                  <div
                    key={index}
                    className={`w-2 h-2 rounded-full ${
                      currentImageIndex === index ? "bg-primary" : "bg-gray-400"
                    }`}
                  ></div>
                ))}
              </div>
            )}
          </div>
        </Link>

        <div className=" bg-primary flex w-full justify-between">
          <div
            className="md:p-4 p-2 w-full flex justify-center items-cente text-white hover:bg-black border-r-[1px]  cursor-pointer"
            onClick={() => handleAddProduct(data)}
          >
            <RiShoppingCartLine />
          </div>
          <div
            className="md:p-4 p-2 w-full flex justify-center items-cente text-white hover:bg-black border-r-[1px] cursor-pointer"
            onClick={() => handleToWish(data)}
          >
            <FaRegHeart />
          </div>
          <div
            className="md:p-4 p-2 w-full flex justify-center items-cente text-white hover:bg-black border-r-[1px] cursor-pointer"
            onClick={() => handleToCompare(data)}
          >
            <FaCodeCompare />
          </div>
          <div
            className="md:p-4 p-2 w-full flex justify-center items-cente text-white hover:bg-black border-r-[1px] cursor-pointer"
            onClick={() => navigate(`/products/${data._id}`)}
          >
            <FaEye />
          </div>
          <div
            className="md:p-4 p-2 w-full flex justify-center items-center text-white hover:bg-black cursor-pointer"
            onClick={handleShare}
          >
            <FaShareAlt />
          </div>
        </div>
        <span className=" bg-red-600 absolute text-[10px] px-2 py-1 text-white capitalize font-bold left-0 top-5">
          {data.label[0]}
        </span>
      </div>
      <div className=" flex flex-col w-full gap-1 p-2">
        <span className=" text-[12px] text-gray-600">
          {categorys.find((cate) => cate._id === data.category)?.name}
        </span>
        {/* <div className="flex items-center mt-1  text-gray-600">
                {[1, 2, 3, 4, 5].map((index) =>
                  index <= data.rate ? (
                    <FaStar key={index} color="#ffa569" />
                  ) : (
                    <FaRegStar key={index} />
                  )
                )}
              </div> */}
        <h4 className=" text-[12px] md:text-[15px] font-bold hover:text-primary cursor-pointer w-fit">
          <Link to={`/products/${data._id}`}>{data.name}</Link>{" "}
          {data.stockStatus !== "in stock" && (
            <span className=" text-red-600">( {data.stockStatus})</span>
          )}
        </h4>
        <h4 className=" text-[12px] md:text-[15px] font-boldw-fit text-red-600 font-bold">
          {" "}
          &#8377; {data.salePrice}{" "}
          <span className=" line-through text-gray-700 font-normal text-[12px]">
            &#8377; {data.price}
          </span>
        </h4>
      </div>
    </div>
  );
};

export default ProductCard;
